/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartDialGuage = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c6.066 0 11 4.935 11 11 0 3.49-1.61 6.697-4.418 8.8l-.267.2H5.686l-.267-.2C2.611 19.697 1 16.49 1 13 1 6.935 5.935 2 12 2zm0 2c-4.962 0-9 4.038-9 9a8.915 8.915 0 0 0 3.361 7H17.64A8.916 8.916 0 0 0 21 13c0-4.962-4.037-9-9-9zm4.293 3.293 1.415 1.414-3 3.002A3.004 3.004 0 0 1 12 16c-1.655 0-3-1.346-3-3a3.004 3.004 0 0 1 4.293-2.707zM12 12a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartDialGuage as ChartDialGuage };
